export class BadGateway extends Error {
  data?: any;

  constructor(data?: any) {
    super('Could not process data');
    this.name = 'Could not process data';
    this.data = data;
  }
}
